module.exports = __webpack_public_path__ + "img/diners.2e5166a1.png";